import lottie from "lottie-web"
import autoLayoutLoading from "assets/images/lottie/autoLayoutLoading.json"
import { Loading, Message } from "element-ui"
export async function loading() {
    let loadingInstance = Loading.service({
        target: document.getElementsByClassName("middle-container")[0],
        lock: true,
        text: "",
        spinner: "loadingLottieWrapper",
        customClass: "autoLayoutLoadingWrapper",
        background: "white"
    })
    let lottieWrapper = document.getElementsByClassName("loadingLottieWrapper")[0]
    lottieWrapper.style.width = "84px"
    lottieWrapper.style.height = "84px"
    lottieWrapper.style.display = "block"
    lottieWrapper.style.margin = "0 auto"
    let lottieInstance = lottie.loadAnimation({
        container: document.getElementsByClassName("loadingLottieWrapper")[0],
        renderer: "svg", // 渲染方式:svg：支持交互、不会失帧、canvas、html：支持3D，支持交互
        loop: true,
        animationData: autoLayoutLoading
    })
    document.getElementsByClassName("el-loading-spinner")[0].style.top = "40%"
    document.getElementsByClassName("el-loading-mask")[0].style.zIndex = 99
    await stop(1500)
    return Promise.resolve(function () {
        loadingInstance.close && loadingInstance.close()
        lottieInstance.destroy && lottieInstance.destroy()
        loadingInstance = null
        lottieInstance = null
        lottieWrapper = null
    })
}

async function stop(time) {
return new Promise((resolve, reject) => {
    setTimeout(() => {
    resolve()
    }, time)
})
}